/* eslint-disable @next/next/no-img-element */
import Link from "next/link";
import PropTypes from "prop-types";
import PLPModal from "@/components/ProductListing/PLPModal";
import Image from "next/legacy/image";
import Styles from "@/components/ProductListing/PLPCards/index.module.scss";
import { useEffect, useState } from "react";
import { getColorSwatches } from "@/components/detailsComponent/helper";
import MissingImage from "/public/image-missing.png";
// import {
//   COMPARE_ERRORS,
//   COMPARE_PRODUCTS_DIFF_CATEGORY_ERROR,
// } from "@/constants";
import CompareStatus from "./compareStatus";
import { UseLocalStorage } from "@/components/CustomHooks/LocalStorage";
import { NumericFormat } from "react-number-format";
import {
  DEFAULT_IMAGE_LINK,
  imageURLWithPresetConfigPLP,
  // staticLabelsPLP,
} from "@/components/ProductListing/helper";
import { getCompareMappings, mapCompareValues } from "@/utils/compareMappings";
import { useContentfulTranslations } from "@/utils/contentfulTranslations";

const NewPLPCard = ({
  selectedSkuId,
  handleModalOpen,
  handleModalClose,
  modalOpen,
  locale = "en",
  item,
  displayCompare = true,
  compareMappingsData = {},
  COMPARE_ERRORS = {},
  COMPARE_PRODUCTS_DIFF_CATEGORY_ERROR = {},
}) => {
  const {
    description = "",
    customerFacingSKU = "",
    productImagesUrlSS = [],
    sku = "",
    slug: productSlug = "",
    productSingleImageUrl = [],
  } = item;

  const { staticLabelsPLP } = useContentfulTranslations();

  const compareProducts = UseLocalStorage("compareProducts");
  const shouldShowModal = compareProducts?.length > 0;

  const swatchImages = getColorSwatches(item?.originalData || {});
  const { productHeading_s: productHeading = "" } = item.originalData || {};

  const compareMappings = getCompareMappings(compareMappingsData);
  const compareMappedValues = mapCompareValues(item, compareMappings);

  const assetOfImage = productSingleImageUrl.length
    ? productSingleImageUrl[0]
    : null;
  const assetIdOfImage = assetOfImage
    ? assetOfImage.split("/")[assetOfImage.split("/").length - 1]
    : null;

  const productImagePath = assetIdOfImage
    ? imageURLWithPresetConfigPLP(assetIdOfImage)
    : MissingImage?.src;

  const plpCompareData = {
    image: productImagePath ? [productImagePath] : productImagesUrlSS,
    fallBackImage: productSingleImageUrl.length
      ? productSingleImageUrl[0]
      : MissingImage?.src,
    swatch: swatchImages,
    skuId: `K-${sku}`,
    slug: productSlug,
    compareMappedValues,
  };

  const [navbarOpen, setNavbarOpen] = useState(shouldShowModal);

  const addToCompare = () => {
    if (typeof window === "undefined") return;

    let existing = JSON.parse(localStorage.getItem("compareProducts")) || [];

    const alreadyExists = existing.some(
      item =>
        item?.compareMappedValues?.skuId ===
        plpCompareData?.compareMappedValues?.skuId
    );

    // Check for different category (productType)
    if (
      existing.length > 0 &&
      !alreadyExists &&
      existing.some(
        item =>
          item?.compareMappedValues?.["Product Type"] !==
          plpCompareData?.compareMappedValues?.["Product Type"]
      )
    ) {
      if (window.confirm(COMPARE_PRODUCTS_DIFF_CATEGORY_ERROR[locale])) {
        // Remove all and add new one
        existing = [plpCompareData];
        localStorage.setItem("compareProducts", JSON.stringify(existing));
        window.dispatchEvent(new Event("storage"));
      } else {
        // Cancelled, do nothing
        return;
      }
      return;
    }

    if (!alreadyExists) {
      if (existing.length < 3) {
        existing.push(plpCompareData);
      } else {
        alert(COMPARE_ERRORS[locale]);
        return;
      }
    }

    localStorage.setItem("compareProducts", JSON.stringify(existing));
    window.dispatchEvent(new Event("storage"));
  };

  const handleRemoveCompareProduct = () => {
    if (typeof window === "undefined") return;
    let existing = JSON.parse(localStorage.getItem("compareProducts")) || [];
    existing = existing.filter(
      item =>
        item?.compareMappedValues?.skuId !==
        plpCompareData?.compareMappedValues?.skuId
    );
    localStorage.setItem("compareProducts", JSON.stringify(existing));
    window.dispatchEvent(new Event("storage"));
    setNavbarOpen(false);
  };

  const handleCompareProduct = () => {
    setNavbarOpen(prev => {
      const newState = !prev;

      // only add when opening
      if (newState) {
        addToCompare();
      }

      return newState;
    });
  };

  useEffect(() => {
    if (modalOpen) {
      typeof document !== "undefined" &&
        document.body.classList.add("!overflow-hidden");
    } else {
      typeof document !== "undefined" &&
        document.body.classList.remove("!overflow-hidden");
    }
  }, [modalOpen]);

  return (
    <>
      <div className={Styles.productCardContainer}>
        <div className="product-tile-inner">
          <div className="product-tile-content">
            <Link
              href={`/product-details/${productSlug}?sku=${sku}`}
              id={`load_${sku}`}
              legacyBehavior
            >
              <a>
                <div className="product-image">
                  <Image
                    src={productImagePath}
                    alt={description}
                    onError={e =>
                      (e.target.src = productSingleImageUrl[0].length
                        ? productSingleImageUrl[0]
                        : MissingImage)
                    }
                    width={300}
                    height={232}
                  />
                </div>
                {productHeading && (
                  <span className="product-description">
                    <span className="product-family">{productHeading}</span>
                  </span>
                )}
                <span className="product-sku">{customerFacingSKU}</span>
                {/* {productSalePrice && Number(productSalePrice) !== 0 && (
                  <span className="product-price">
                    <NumericFormat
                      aria-description={"price"}
                      value={productSalePrice}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"IDR "}
                      decimalScale={0}
                      fixedDecimalScale={true}
                    />
                  </span>
                )} */}
              </a>
            </Link>
          </div>

          <div className="product-tile-actions">
            <div className="product-quick-view">
              <button
                type="button"
                className="product-quick-view-button"
                onClick={() => handleModalOpen(sku)}
              >
                <span className="label">
                  {staticLabelsPLP?.[locale]?.quickView}
                </span>
              </button>
            </div>
            {displayCompare && (
              <div className={Styles.compareWrapper}>
                <CompareStatus
                  displayCompare={displayCompare}
                  plpCompareData={plpCompareData}
                  handleCompareProduct={handleCompareProduct}
                  handleRemoveCompareProduct={handleRemoveCompareProduct}
                  locale={locale}
                  staticLabelsPLP={staticLabelsPLP}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {modalOpen && selectedSkuId === sku ? (
        <PLPModal
          handleModalClose={handleModalClose}
          modalItem={item}
          ProductProductNo={item.ProductProductNo}
          locale={locale}
          selectedSkuId={selectedSkuId}
          addToCompare={addToCompare}
          removeFromCompare={handleRemoveCompareProduct}
          displayQuickViewMasterPLP={displayCompare}
          plpCompareData={plpCompareData}
          staticLabelsPLP={staticLabelsPLP}
        />
      ) : null}
    </>
  );
};

NewPLPCard.propTypes = {
  handleMouseOver: PropTypes.func,
  handleMouseOut: PropTypes.func,
  isHovering: PropTypes.bool,
  skuId: PropTypes.string,
  handleModalOpen: PropTypes.func,
  handleModalClose: PropTypes.func,
  modalOpen: PropTypes.bool,
  locale: PropTypes.string,
  item: PropTypes.shape({
    SkuNumber: PropTypes.string,
    SkuResourceImgName: PropTypes.string,
    ProductNewProduct: PropTypes.string,
    ProductProductNo: PropTypes.string,
    ProductBrandName: PropTypes.string,
    ProductDescriptionProductShort: PropTypes.string,
    description: PropTypes.string,
    productCollectionsName: PropTypes.string,
  }),
};

export default NewPLPCard;
